{
  "register-secret-data-page": {
    "buttons": {
      "back": "Back",
      "submit": "Submit"
    },
    "text": {
      "login-data": "Your login data",
      "login-data-hint": "You need to set your login data"
    }
  }
}
